<template>
  <div
    style="
      width: 100vw;
      height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
      overflow: hidden;
      background-image: linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%);
    "
    class="login-page-container"
  >
    <!-- 添加窗帘动画遮罩层 -->
    <div class="curtain curtain-left"></div>
    <div class="curtain curtain-right"></div>

    <div v-if="ProjectId" style="width: 100%; height: 100%" class="fade-in">
      <div style="" v-loading.fullscreen.lock="loading">
        <div style="position: relative; width: 100vw; height: 100vh">
          <el-row style="width: 100%; height: 100%">
            <el-col :span="16" style="height: 100%" class="slide-in-left">
              <el-image
                :src="ProjectInfo.ProjectImg"
                fit="fill"
                style="width: 100%; height: 100%"
              ></el-image>
            </el-col>
            <el-col
              :span="8"
              style="
                overflow: hidden;
                height: 100%;
                background-color: #fff;
                position: relative;
              "
              class="slide-in-right"
            >
              <div
                style="
                  font-size: 32px;
                  font-weight: bold;
                  text-align: center;
                  line-height: 100px;
                  color: #000;

                  position: absolute;
                  top: 100px;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  z-index: 90;
                  width: 100%;
                "
                class="ellipsis fade-in-delay"
              >
                {{ ProjectInfo.Name }}
              </div>

              <el-card
                style="
                  width: 40%;
                  min-width: 400px;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  z-index: 100;
                "
                class="zoom-in-card"
              >
                <div
                  style="
                    font-weight: bold;
                    font-size: 20px;
                    margin-bottom: 20px;
                  "
                >
                  欢迎登录
                </div>
                <div style="font-size: 16px; margin-bottom: 10px">邀请码</div>
                <div style="margin-bottom: 20px">
                  <el-input
                    v-model="token"
                    placeholder="请输入邀请码"
                    size="mini"
                  ></el-input>
                </div>
                <div style="font-size: 16px; margin-bottom: 10px">手机号</div>
                <div style="margin-bottom: 20px">
                  <el-input
                    v-model="Phone"
                    placeholder="请输入手机号"
                    size="mini"
                    type="number"
                  >
                    <!-- <i
    class="el-icon-edit el-input__icon"
    slot="suffix"
    @click="handleIconClick">
  </i> -->
                    <!-- <template slot="suffix">
                      <el-button
                        @click="sendCode"
                        type="text"
                        :disabled="isSending || countdown > 0"
                      >
                        {{
                          isSending
                            ? "获取中..."
                            : countdown > 0
                            ? `${countdown}秒后重试`
                            : "获取验证码"
                        }}
                      </el-button>
                    </template> -->
                  </el-input>
                </div>
                <!-- <div style="font-size: 16px; margin-bottom: 10px">验证码</div>
                <div style="margin-bottom: 20px">
                  <el-input
                    v-model="code"
                    placeholder="请输入验证码"
                    size="mini"
                    type="number"
                  ></el-input>
                </div> -->
                <div style="text-align: center">
                  <el-button type="primary" @click="enter" style="width: 100%"
                    >进入</el-button
                  >
                </div>
              </el-card>
              <div
                v-if="ProjectInfo.Describe"
                style="
                  text-align: center;
                  font-size: 14px;

                  color: #909399;
                  width: 40%;
                  min-width: 400px;
                  margin: 0 auto;
                  position: absolute;
                  bottom: 7%;
                  left: 50%;
                  z-index: 90;
                  transform: translate(-50%, -50%);
                "
              >
                <div style="text-align-last: left; font-weight: bold">
                  项目描述:
                </div>
                <div class="ellipsis3">
                  {{ ProjectInfo.Describe }}
                </div>
              </div>
              <div
                style="
                  position: absolute;
                  bottom: 10px;
                  left: 0;
                  z-index: 90;
                  width: 100%;
                  color: #909399;
                  text-align: center;
                  font-size: 12px;
                "
              >
                技术支持：{{ ProjectInfo.CreatorPhone }}<br />
                Copyright©2021-2025版权所有：铂诺客智能科技（北京）有限公司
              </div>
            </el-col>
          </el-row>
          <!-- -->
        </div>
        <!-- <el-row>
          <el-col :span="12">
            <div
              style="text-align: center; font-size: 60px; color: #fff; font-weight: bold"
            >
              {{ ProjectInfo.Name }}
            </div>
            <el-image
              :src="ProjectInfo.ProjectImg"
              fit="contain"
              style="width: 100%; height: 100vh"
            ></el-image>
          </el-col>
        </el-row> -->
        <!-- <div
          style="
            position: absolute;
            top: 5vh;
            left: 0;
            width: 100%;
            text-align: center;
            font-size: 60px;
            color: #fff;
            font-weight: bold;
          "
        >
          供 应 商 资 料 上 传 客 户 端
        </div> -->
        <!---->
      </div>
    </div>
    <div v-else>
      <el-empty>
        <template slot="description">
          <span style="color: red; font-size: 20px; font-weight: bold"
            >页面加载失败，请联系管理员检查分享链接是否有效。</span
          >
        </template>
      </el-empty>
    </div>
  </div>
</template>
<script>
import TokenCache from '@/utils/cache/TokenCache'
export default {
  data() {
    return {
      token: '',
      Phone: '',
      code: '',
      loading: false,
      ProjectId: '',
      ProjectInfo: {},
      base_Supplier: [],
      countdown: 0,
      isSending: false,
    }
  },
  props: {},
  components: {},
  methods: {
    //倒计时开始
    startCountdown() {
      this.countdown = 60
      const timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(timer)
        }
      }, 1000)
    },
    getVerificationCode() {
      //获取验证码
      this.isSending = true
      setTimeout(() => {
        this.startCountdown()
        this.isSending = false
      }, 2000)
    },
    isValidPhoneNumber(phoneNumber) {
      return /^1[3-9]\d{9}$/.test(phoneNumber)
    },
    async sendCode() {
      if (this.countdown > 0 || this.isSending) {
        return // 防止重复点击获取
      }

      if (!this.isValidPhoneNumber(this.Phone)) {
        this.$notify.warning('请输入正确的手机号')
        return
      }
      this.getVerificationCode()

      // 假设在这个方法中实现获取验证码的逻辑
      // 可以调用sendVerificationCode()方法获取验证码
      // 这里只是简单模拟获取过程
      // this.isSending = true;
      // this.startCountdown();

      // setTimeout(() => {
      //     // 假设获取成功后将isSending重置为false
      //     this.isSending = false;
      // }, 2000); // 这里使用2秒的延迟来模拟获取过程，你需要替换为实际的获取逻辑
    },
    enter() {
      if (!this.token) {
        this.$notify.error('请输入邀请码')
        return
      }
      if (!this.isValidPhoneNumber(this.Phone)) {
        this.$notify.error('请输入正确手机号')
        return
      }
      if (!this.Phone) {
        this.$notify.error('请输入手机号')
        return
      }
      this.loading = true
      this.$http
        .post('/Base_BasicData/Base_SupplierToken/SubmitSupplierLogin', {
          ProjectId: this.ProjectId,
          Token: this.token,
          Phone: this.Phone,
          SmsCode: this.code,
        })
        .then(async (res) => {
          this.loading = false
          if (res.Success) {
            TokenCache.setToken(res.Data.SupToken)
            await this.$store.dispatch('getUserInfo')
            // 设置Vuex登录标志为true，默认userLogin为false
            await this.$store.dispatch('setUser', true)

            this.ProjectInfo = res.Data.base_Project
            window.localStorage.setItem(
              'ProjectInfo',
              JSON.stringify(res.Data.base_Project)
            )
            this.base_Supplier = {
              ...res.Data.base_Supplier,
            }

            window.localStorage.setItem(
              'base_Supplier',
              JSON.stringify(this.base_Supplier)
            )
            window.localStorage.setItem('Grade', res.Data.Grade)
            window.localStorage.setItem('TrueOrFalse', res.Data.TrueOrFalse)
            window.localStorage.setItem('tokenCode', this.token)
            //判断是否是首次进入未填写资质信息
            if (res.Data.TrueOrFalse) {
              this.$router.push({
                path: '/TemplateHome',
              })
            } else {
              this.$router.push({
                path: '/TemplateUser',
              })
            }

            // this.isLogin = true;
          } else {
            this.$notify.error(res.Msg)
          }
        })

      //进入接口

      // this.isLogin = true;
      // this.getInfo();
      // this.getTreeData();
    },
    getProjectInfo() {
      this.loading = true
      this.$http
        .post('/Base_ProjectWork/Base_Project/GetTheData', {
          id: this.ProjectId,
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.ProjectInfo = res.Data
            window.localStorage.setItem(
              'exeProjectInfo',
              JSON.stringify(res.Data)
            )
          }
        })
    },
  },
  mounted() {},
  created() {
    if (this.$route.query.ProjectId) {
      this.ProjectId = this.$route.query.ProjectId
      window.localStorage.setItem('exeProjectId', this.ProjectId)
      this.getProjectInfo()
    } else {
      window.localStorage.setItem('exeProjectId', '')
      this.ProjectId = ''
    }
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-tree-node {
  white-space: normal;
}

::v-deep .el-tree-node__content {
  height: 100%;
  align-items: start;
}

::v-deep .el-tree-node {
  padding-top: 2px;
  padding-bottom: 2px;
}

::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #409eff;
  color: #fff;
  font-weight: bold;
}

/* 窗帘动画 */
.curtain {
  position: fixed;
  width: 50%;
  height: 100vh;
  background-color: #333;
  z-index: 1000;
  top: 0;
}

.curtain-left {
  left: 0;
  animation: curtainLeft 1.5s ease-in-out forwards;
}

.curtain-right {
  right: 0;
  animation: curtainRight 1.5s ease-in-out forwards;
}

@keyframes curtainLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

@keyframes curtainRight {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(100%);
  }
}

/* 调整其他动画延迟，在窗帘动画之后执行 */
.fade-in {
  animation: fadeIn 1s ease-in-out 1.2s both;
}

.fade-in-delay {
  animation: fadeIn 1.2s ease-in-out 1.5s both;
}

.slide-in-left {
  animation: slideInLeft 1s ease-out 1.2s both;
}

.slide-in-right {
  animation: slideInRight 1s ease-out 1.2s both;
}

.zoom-in-card {
  animation: zoomIn 0.8s ease-out 1.7s both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideInLeft {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideInRight {
  from {
    transform: translateX(50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes zoomIn {
  from {
    transform: translate(-50%, -50%) scale(0.9);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}

.login-page-container {
  animation: gradientAnimation 15s ease infinite;
  background-size: 400% 400%;
}

@keyframes gradientAnimation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
